import React from 'react';
import { Menu, PanelRight } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { PrimaryRoutes } from 'common/enums/internal-route-enums';

type TopbarProps = {
  onOpenLeft: () => void;
  onOpenRight: () => void;
};

export const Topbar: React.FC<TopbarProps> = ({ onOpenLeft, onOpenRight }) => {
  const location = useLocation();
  const isAIAnalystPage = location.pathname.startsWith(PrimaryRoutes.AIAnalyst);
  
  return (
    <header className="md:hidden sticky top-0 z-50 flex items-center justify-between h-12 bg-white px-3">
      <button
        onClick={onOpenLeft}
        aria-label="Open left menu"
        className="p-2 rounded-md hover:bg-gray-100 active:scale-95 transition"
      >
        <Menu className="w-5 h-5" />
      </button>

      
      {/* Only show right panel button on AI Analyst page */}
      {isAIAnalystPage ? (
        <button
          onClick={onOpenRight}
          aria-label="Open right panel"
          className="p-2 rounded-md hover:bg-gray-100 active:scale-95 transition"
        >
          <PanelRight className="w-5 h-5" />
        </button>
      ) : (
        // Empty div to maintain spacing and layout consistency
        <div className="w-9 h-9"></div>
      )}
    </header>
  );
};
